import React, { useCallback, useMemo, } from 'react';
import Box from '@material-ui/core/Box';

import { useWidth, } from 'common/hooks';
import { Loader, } from 'common/components/Loader';
import { LoaderType, } from 'common/components/Loader/types';
import ProductsItemContainer from './Item/ItemContainer';

const mobileView = [ 'sm', 'xs', ];

const ProductLoaderSkeleton = () => {
    const currentWidth = useWidth();

    const renderDesktopSvg = useCallback(() => (
        <>
            <rect x="22" y="0" rx="0" ry="0" width="150" height="188"/>
            <rect x="203" y="2" rx="0" ry="0" width="430" height="29"/>
            <rect x="206" y="43" rx="0" ry="0" width="203" height="16"/>
            <rect x="207" y="73" rx="0" ry="0" width="333" height="113"/>
            <rect x="666" y="55" rx="0" ry="0" width="120" height="29"/>
            <rect x="668" y="121" rx="0" ry="0" width="119" height="29"/>
        </>
    ), []);

    const renderMobileSvg = useCallback(() => (
        <>
            <rect x="325" y="6" rx="0" ry="0" width="153" height="139" />
            <rect x="207" y="154" rx="0" ry="0" width="399" height="54" />
        </>
    ), []);

    const renderLoader = mobileView.includes(currentWidth) ? renderMobileSvg : renderDesktopSvg;

    const renderProducts = useCallback((_: unknown, index: number) => (
        <Box key={index}
             my={2}>
            <ProductsItemContainer>
                <Loader isLoading={true}
                        style={{ width:'100%', }}
                        speed={2}
                        height={200}
                        viewBox="0 0 800 200"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        loaderType={LoaderType.CUSTOM_SVG}
                        render={renderLoader}/>
            </ProductsItemContainer>
        </Box>
    ), [ renderLoader, ]);

    const items = useMemo(
        () => Array.from({ length: 5, }).map(renderProducts),
        [ renderProducts, ]
    );

    return (
        <>{items}</>
    );
};

export default ProductLoaderSkeleton;
